import api from './api';

const BASE_PATH = '/admin/learning_objectives';

/**
 * Cliente dos objetivos de aprendizagem (matriz de referência do Projeto Floriano).
 * Backend em app/controllers/api/v1/admin/learning_objectives_controller.rb.
 *
 * Os objetivos NÃO devem ser hardcoded no frontend: a lista vem sempre de `index`,
 * para que novas etapas cadastradas no backend apareçam sozinhas na tela.
 */
export const learningObjectivesApi = {
  // GET /api/v1/admin/learning_objectives
  index: () => api.get(BASE_PATH),

  // GET /api/v1/admin/learning_objectives/:id/coverage
  coverage: id => api.get(`${BASE_PATH}/${id}/coverage`),

  // GET /api/v1/admin/learning_objectives/:id/descriptors
  descriptors: id => api.get(`${BASE_PATH}/${id}/descriptors`),

  // GET /api/v1/admin/learning_objectives/:id/descriptor_links?status=pending
  descriptorLinks: (id, status) =>
    api.get(`${BASE_PATH}/${id}/descriptor_links`, {
      params: status ? { status } : undefined
    }),

  // POST /api/v1/admin/learning_objectives/:id/publish
  publish: (id, password) => api.post(`${BASE_PATH}/${id}/publish`, { password })
};

export default learningObjectivesApi;
